export default "__VITE_ASSET__oVOpY6rf__"